import React, { ChangeEvent, useCallback } from "react";
import { Image } from "react-bootstrap";
import { Contact } from "src/types/contact";

import styles from "./avatar.module.scss";
import _ from "lodash";

interface IAvatar {
  contact: Contact;
  enableCrop?: () => void;
  changeProfileImage: (image: any) => void;
}

const Avatar: React.FC<IAvatar> = ({
  contact,
  enableCrop,
  changeProfileImage,
}) => {
  const fileUploadRef = React.useRef<HTMLInputElement>(null);
  const icon = _.get(contact, "icon.thumbnail");
  const convertToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
})
  const renderProfileImage = useCallback(() => {
    if (icon) {
      return <Image className={styles.profileImage} src={icon} roundedCircle />;
    } else {
      return (
        <div className={styles.profileImage}>
          <span>{(contact.firstName || "")[0]}</span>
          <span>{(contact.lastName || "")[0]}</span>
        </div>
      );
    }
  }, [contact.id]);

  return (
    <div className={styles.avatar}>
      {renderProfileImage()}
      <div
        className={styles.overlay}
        onClick={() => {
          fileUploadRef.current?.click();
        }}
      >
        <i className="paperflite-edit" />
        <input
          type="file"
          accept="image/*"
          ref={fileUploadRef}
          className={styles.fileUpload}
          onChange={async (event: ChangeEvent<HTMLInputElement>) => {
            const file = event.target.files?.[0];
            if (!file) return;
            convertToBase64(file).then((result) => {
              changeProfileImage(result);
              if (enableCrop) {
                enableCrop();
              }
            })
          }}
        />
      </div>
    </div>
  );
};

export default Avatar;
